export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  header: "site-header",
  logo: "site-logo",
  linkLive: "nav-link-live",
  linkForecast: "nav-link-forecast",
  linkTeam: "nav-link-team",
  linkAdmin: "nav-link-admin",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  wrapper: "live-stream-hero",
  livePlayer: "live-stream-player",
  livePill: "live-pill",
};

export const CITY = (id) => ({
  card: `city-card-${id}`,
  temp: `city-temp-${id}`,
});

export const ALERT = {
  banner: "alert-banner",
  ticker: "alert-ticker",
};

export const VIDEO = {
  grid: "videos-grid",
  card: (id) => `video-card-${id}`,
  playBtn: (id) => `video-play-${id}`,
  dialog: "video-dialog",
  closeDialog: "video-dialog-close",
};

export const TEAM = { grid: "team-grid" };

export const FOOTER = {
  root: "site-footer",
  fb: "social-facebook",
  x: "social-twitter",
  yt: "social-youtube",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabStream: "admin-tab-stream",
  tabVideos: "admin-tab-videos",
  tabAlerts: "admin-tab-alerts",
  tabTeam: "admin-tab-team",
  streamInput: "admin-stream-input",
  streamSave: "admin-stream-save",
  videoTitle: "admin-video-title",
  videoUrl: "admin-video-url",
  videoDesc: "admin-video-desc",
  videoAdd: "admin-video-add",
  videoDelete: (id) => `admin-video-delete-${id}`,
  alertTitle: "admin-alert-title",
  alertMsg: "admin-alert-msg",
  alertSeverity: "admin-alert-severity",
  alertAdd: "admin-alert-add",
  alertDelete: (id) => `admin-alert-delete-${id}`,
  teamName: "admin-team-name",
  teamRole: "admin-team-role",
  teamBio: "admin-team-bio",
  teamImg: "admin-team-img",
  teamAdd: "admin-team-add",
  teamDelete: (id) => `admin-team-delete-${id}`,
};
